export default {
    validate(value, end) {
        return value.endsWith(end);
    }
};